import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";
import { getFontFamily, toRGBA } from "../parser/utils";

export default ({ data }) => {
  const {
    options,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    optionsHorizonAlignment,
    labelFontColor,
    labelDefaultFont,
    labelFontSize,
    labelHorizonAlignment,
  } = data;
  const { state } = useEditorContext();
  const { formTextColor, formBorderWidth, formBorderStyle, formBorderColor } =
    state.root.data;
  const borderStyleObj = {
    ...getBorderStyleObj(state.root.data),
    display: "flex",
    flexDirection: "column",
  };

  const customLabelStyle = {
    color: toRGBA(labelFontColor || formTextColor),
    fontFamily: labelDefaultFont,
    fontSize: labelFontSize,
    justifyContent: labelHorizonAlignment || "start",
  };

  const optionFontFamily = getFontFamily(
    optionsDefaultFont,
    state.root.data.defultFont
  );

  // 内联注入，覆盖所有行的 height、wrap、label 换行等
  const injectedStyles = `
    .rip-options-container { display: flex; flex-direction: column; }
    .rip-option-row {
      display: flex !important;
      flex-wrap: wrap !important;
      height: auto !important;
      align-items: flex-start !important;
      padding: 6px 8px !important;
      gap: 8px !important;
      border-bottom: inherit !important;
    }
    .rip-option-row input {
      // flex: 0 0 auto !important;
      margin: 0 !important;
    }
    .rip-option-label {
      // flex: 1 1 auto !important;
      white-space: normal !important;
      word-break: break-word !important;
      margin: 0 !important;
      display: flex !important;
      align-items: center !important;
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: injectedStyles }} />
      <div
        style={{
          paddingTop,
          paddingBottom,
          paddingRight,
          paddingLeft,
        }}
      >
        <FormLabel data={data} customLabelStyle={customLabelStyle} />

        <div className="rip-options-container" style={borderStyleObj}>
          {options.map((item, index) => {
            const isLast = index === options.length - 1;
            const borderBottom = isLast
              ? 0
              : [
                  `${formBorderWidth}px`,
                  formBorderStyle,
                  toRGBA(formBorderColor),
                ].join(" ");

            return (
              <div
                key={index}
                className="rip-option-row"
                style={{
                  display: "flex",
                  borderBottom,
                  justifyContent: optionsHorizonAlignment,
                  /* 原来的 height/padding/gap 会被 !important 覆盖 */
                }}
              >
                <div
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    border: "1px solid #cccccc",
                  }}
                />
                <div
                  className="rip-option-label"
                  style={{
                    justifyContent: optionsHorizonAlignment,
                    color: toRGBA(optionsFontColor || formTextColor),
                    fontFamily: optionFontFamily,
                    fontSize: `${optionsFontSize}px`,
                  }}
                >
                  {item.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
